<template>
  <div class="max-w-2xl mx-auto mt-20" v-if="settings">
    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      {{ settings?.title }}
    </h1>
    <p class="mt-5 text-gray-700 md:text-center">
      {{ settings?.sub_title }}
    </p>
  </div>
  <div class="max-w-5xl mx-auto mt-5" v-if="latestHomes">
    <div>
      <header class="flex items-center justify-between mb-4">
        <p class="mt-2 text-gray-700">
          Discover how we can help you find your dream home
        </p>
      </header>
      <div class="mx-4">
        <vue-horizontal
          responsive
          class="horizontal"
          :displacement="0.7"
          snap="center"
        >
          <a
            :href="
              $router.resolve({
                name: 'PropertyView',
                params: {
                  id: property.id,
                  slug: property.title ? $sanitizeTitle(property.title) : '',
                },
              }).href
            "
            class="flex mx-2"
            v-for="property in latestHomes.data.slice(0, 12)"
            :key="property.id"
          >
            <div class="relative flex flex-col items-start w-56">
              <div
                class="max-w-[300px] max-h-[300px] overflow-hidden rounded-md"
              >
                <img
                  :src="property.photos[0]"
                  class="object-cover w-56 h-40 transition duration-500 rounded-md cursor-pointer hover:scale-110"
                  alt=""
                />
              </div>
              <div class="flex flex-col">
                <h1 class="text-xl font-semibold text-gray-800 text-start">
                  {{ formattedAmount(Number(property.price), 2) }}
                </h1>
                <div class="flex space-x-2 font-medium">
                  <div
                    class="flex items-center justify-center"
                    v-if="property.number_of_beds"
                  >
                    <BedSvg color="black" height="4" width="4" />
                    <p class="pl-1 text-xs">{{ property.number_of_beds }}bd</p>
                  </div>
                  <div
                    class="flex items-center justify-center"
                    v-if="property.number_of_baths"
                  >
                    <BathSvg color="black" height="4" width="4" />
                    <p class="pl-1 text-xs">{{ property.number_of_baths }}ba</p>
                  </div>
                  <div
                    class="flex items-center justify-center"
                    v-if="property.property_size"
                  >
                    <PropertySizeSvg color="black" height="3" width="3" />
                    <p class="pl-1 text-xs truncate">
                      {{ $truncate(property.property_size, 12) }}
                    </p>
                  </div>
                </div>
                <p
                  class="text-sm font-normal tracking-wide truncate text-start"
                >
                  {{ property.address }}
                </p>
                <p class="text-[10px] text-start uppercase overflow-hidden">
                  {{ $truncate(property.title, 40) }}
                </p>
              </div>
            </div>
          </a>
        </vue-horizontal>
      </div>
    </div>
    <div class="mx-4 mt-10" v-if="latestHomes && latestHomes.length >= 13">
      <vue-horizontal
        responsive
        :button="false"
        ref="horizontal"
        @scroll-debounce="onScroll"
      >
        <a
          :href="
            $router.resolve({
              name: 'PropertyView',
              params: {
                id: property.id,
                slug: property.title ? $sanitizeTitle(property.title) : '',
              },
            }).href
          "
          class="flex mx-2"
          v-for="property in latestHomes.data.slice(13, 24)"
          :key="property.id"
        >
          <div class="relative flex flex-col items-start w-56">
            <div class="max-w-[300px] max-h-[300px] overflow-hidden rounded-md">
              <img
                :src="property.photos[0]"
                class="object-cover w-56 h-40 transition duration-500 rounded-md cursor-pointer hover:scale-110"
                alt=""
              />
            </div>
            <!-- <div class="absolute top-0 left-0 flex pl-2 mt-2 space-x-1 text-xs">
              <div
                class="flex items-center justify-center h-5 px-1 text-xs font-semibold text-blue-700 uppercase bg-white rounded"
              >
                <p class="tracking-wide">NEW</p>
              </div>
              <div
                class="flex items-center justify-center h-5 px-1 text-xs font-semibold text-blue-700 uppercase bg-white rounded"
              >
                <p class="tracking-wide">OPEN FRI, 4-6PM</p>
              </div>
            </div> -->
            <div class="flex flex-col">
              <h1 class="text-xl font-semibold text-gray-800 text-start">
                {{ formattedAmount(Number(property.price), 2) }}
              </h1>
              <div class="flex space-x-1 font-medium">
                <div class="flex items-center justify-center">
                  <div class="w-5 h-5">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <path
                        d="M9.196 14.603h15.523v.027h1.995v10.64h-3.99v-4.017H9.196v4.017h-3.99V6.65h3.99v7.953zm2.109-1.968v-2.66h4.655v2.66h-4.655z"
                        fill="#869099"
                      />
                    </svg>
                  </div>
                  <p class="text-xs">{{ property.number_of_beds }}bd</p>
                </div>
                <div class="flex items-center justify-center">
                  <div class="w-5 h-5">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <path
                        d="M23.981 15.947H26.6v1.33a9.31 9.31 0 0 1-9.31 9.31h-2.66a9.31 9.31 0 0 1-9.31-9.31v-1.33h16.001V9.995a2.015 2.015 0 0 0-2.016-2.015h-.67c-.61 0-1.126.407-1.29.965a2.698 2.698 0 0 1 1.356 2.342H13.3a2.7 2.7 0 0 1 1.347-2.337 4.006 4.006 0 0 1 3.989-3.63h.67a4.675 4.675 0 0 1 4.675 4.675v5.952z"
                        fill="#869099"
                      />
                    </svg>
                  </div>
                  <p class="text-xs">{{ property.number_of_baths }}ba</p>
                </div>
                <div class="flex items-center justify-center">
                  <div class="w-5 h-5">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <path
                        d="M13.748 21.276l-3.093-3.097v3.097h3.093zm12.852 5.32H10.655v.004h-5.32v-.004H5.32v-5.32h.015V5.32L26.6 26.596z"
                        fill="#869099"
                      />
                    </svg>
                  </div>
                  <p class="text-xs truncate">
                    {{ $truncate(property.property_size, 18) }}
                  </p>
                </div>
              </div>
              <p class="text-sm font-normal tracking-wide truncate text-start">
                {{ property.address }}
              </p>
              <p class="text-[10px] text-start uppercase truncate">
                {{ $truncate(property.title, 40) }}
              </p>
            </div>
          </div>
        </a>
      </vue-horizontal>
    </div>
  </div>
</template>

<script>
import BathSvg from "@/components/svg/BathSvg.vue";
import BedSvg from "@/components/svg/BedSvg.vue";
import PropertySizeSvg from "@/components/svg/PropertySizeSvg.vue";
import VueHorizontal from "vue-horizontal";
export default {
  components: {
    VueHorizontal,
    PropertySizeSvg,
    BathSvg,
    BedSvg,
  },
  props: {
    latestHomes: Object,
    settings: Object,
  },
  data() {
    return {};
  },

  methods: {},
};
</script>
